import React from 'react';
import '../DataCollectionGroupPanel.css';
import { Table, ProgressBar } from 'react-bootstrap';
import UnitCellSection from './UnitCellSection.js';

export default class AutoProcIntegrationSection extends React.Component {  

     getColorProgressBarByCompleness(completeness){        
        if (parseFloat(completeness) > 90){
            return "primary";
        }
        if (parseFloat(completeness) > 50){
            return "warning";
        }
        return "danger";

    }

    getShellStatistics(type, completeness, resolutionLimitLow,resolutionLimitHigh, rMerge){
        return  <tr>
            <td>{type}</td>
            <td ><ProgressBar  bsStyle={this.getColorProgressBarByCompleness(completeness)} now={completeness} label={completeness + "%"} /> </td>
            <td>{resolutionLimitLow} - {resolutionLimitHigh}</td>
            <td>{rMerge}</td>
        </tr> ;
    }
    /*
        <tr style={{borderTop:'1px solid rgb(128, 128, 128)', borderCollapse:'collapse'}}>
            <td  className="parameterValue" style={{textAlign:'center'}} colspan="4">{bestResult.processingProgram}</td>                        
        </tr>
    */
    render(){        
        var bestResult = this.props.bestResult;
        return  <div>
                    <Table responsive condensed className="parameterKey" >
                        <thead>                    
                            <tr>
                                <td className="parameterValue">{bestResult.v_datacollection_summary_phasing_autoproc_space_group}</td>
                                <td className="parameterValue">Completeness</td>
                                <td className="parameterValue">Res.</td>
                                <td className="parameterValue">Rmerge</td>
                            </tr>
                        </thead> 
                        <tbody> 
                            {this.getShellStatistics("Overall", bestResult.overall.completeness, bestResult.overall.resolutionLimitLow, bestResult.overall.resolutionLimitHigh, bestResult.overall.rMerge)}
                            {this.getShellStatistics("Inner", bestResult.innerShell.completeness, bestResult.innerShell.resolutionLimitLow, bestResult.innerShell.resolutionLimitHigh, bestResult.innerShell.rMerge)}
                            {this.getShellStatistics("Outer", bestResult.outerShell.completeness, bestResult.outerShell.resolutionLimitLow, bestResult.outerShell.resolutionLimitHigh, bestResult.outerShell.rMerge)}
                        </tbody>                             
                    </Table>
                    <UnitCellSection
                            cell_a = {bestResult.innerShell.cell_a}
                            cell_b = {bestResult.innerShell.cell_b}
                            cell_c = {bestResult.innerShell.cell_c}
                            cell_alpha = {bestResult.innerShell.cell_alpha}
                            cell_beta = {bestResult.innerShell.cell_beta}
                            cell_gamma = {bestResult.innerShell.cell_gamma}                    
                    ></UnitCellSection>                   
            </div>;
    }
}




// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/SummaryDataCollectionGroup/AutoprocIntegrationSection.js